export class UpdateInsuranceFailedResponse {
  code!: string;
  description!: string;
}
